// 判断当前设备是否为移动设备
export function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileRegex =
    /iPhone|iPod|iPad|Android|BlackBerry|IEMobile|Opera Mini|Windows Phone|Mobile/i;

  return mobileRegex.test(userAgent);
}
export function replaceUrl(url) {
  const h = window.location.host;
  if (h.startsWith("localhost")) {
    return "http://localhost:5173" + "/#" + url;
  } else {
    return (
      window.location.protocol +
      "//" +
      window.location.host +
      "/h5" +
      url
    );
  }
}
